import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';



@Component({
  selector: 'app-child',
  templateUrl: './community.component.html',
  providers: [ ]
})
export class CommunityComponent implements OnInit {
  
  
  @Output() messageEvent = new EventEmitter<string>();
  constructor() { }
 
    ngOnInit() {
     
    }
  }


// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/community/community.component.ts